export class ServerModel {
    new_pos = false;

    constructor(data) {
        if (!data || !data.new_pos) return;

        this.new_pos = data.new_pos || false;
    }
}



// WEBPACK FOOTER //
// ./src/helper/version/Server.model.js